import _ from 'lodash';
import { preload } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import { fetchReviewsPage } from 'app/api/product-api';
import ReviewsPage from 'app/components/product/reviews';

const mapStateToProps = state => ({
  page: _.get(state, 'product.yotpoReviewsPage'),
});

const ReviewsContainer = connect(mapStateToProps)(preload(
  ({ dispatch }) => dispatch(fetchReviewsPage()))(ReviewsPage),
);

export default ReviewsContainer;



// WEBPACK FOOTER //
// ./app/containers/product/reviews.js